import isEmpty from 'lodash-es/isEmpty';
import isNil from 'lodash-es/isNil';
import { useMemo } from 'react';
const usePlotDevicesIds = (plot) => {
    const ids = useMemo(() => {
        const deviceIds = [];
        if (!isEmpty(plot?.currentMeasurementConfigs)) {
            plot?.currentMeasurementConfigs.forEach((conf) => {
                if (!isNil(conf.deviceId) && isNil(conf.endDate) && !deviceIds.includes(conf.deviceId)) {
                    deviceIds.push(conf.deviceId);
                }
            });
        }
        return deviceIds;
    }, [plot?.currentMeasurementConfigs]);
    return ids;
};
export default usePlotDevicesIds;
